export const FilterCategoryCardSkeleton = () => {
  return (
    <div className="px-4 py-2 rounded-lg border border-gray-200 bg-gray-50">
      <div className="flex items-center gap-2">
        <div className="w-[28px] h-[28px] rounded-md bg-gray-200 animate-pulse"></div>
        <div className="w-20 h-6 bg-gray-200 rounded-md animate-pulse"></div>
      </div>
    </div>
  );
};